"use client";

import { ReactNode, useRef } from "react";
import { Provider } from "react-redux";
import { makeStore, AppStore, RootState } from "../lib/redux/store";

export default function StoreProvider({
    children,
    preloadedState
}: {
    children: ReactNode,
    preloadedState?: Partial<RootState>;

}) {
    const storeRef = useRef<AppStore>(null);
    if (!storeRef.current) {
        // Create the store instance the first time this renders
        storeRef.current = makeStore(preloadedState);
    }

    return <Provider store={storeRef.current}>{children}</Provider>;
}
